import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Camera: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666' }) => {
  return (
    /*@ts-ignore*/
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
      <path
        fill={fill}
        fill-rule="evenodd"
        d="M9.643 2c.446 0 .862.223 1.11.594l.74 1.11c.123.185.331.296.554.296h.62c1.104 0 2 .895 2 2v6c0 1.105-.896 2-2 2H3.333c-1.104 0-2-.895-2-2V6c0-1.105.896-2 2-2h.62c.223 0 .431-.111.555-.297l.74-1.11C5.495 2.224 5.91 2 6.357 2h3.286zm0 1.333H6.357l-.74 1.11c-.37.556-.995.89-1.664.89h-.62c-.368 0-.666.299-.666.667v6c0 .368.298.667.666.667h9.334c.368 0 .667-.299.667-.667V6c0-.368-.299-.667-.667-.667h-.62c-.669 0-1.293-.334-1.664-.89l-.74-1.11zM8 6c1.473 0 2.667 1.194 2.667 2.667 0 1.472-1.194 2.666-2.667 2.666-1.473 0-2.667-1.194-2.667-2.666C5.333 7.194 6.527 6 8 6zm0 1.333c-.736 0-1.333.597-1.333 1.334C6.667 9.403 7.264 10 8 10c.737 0 1.333-.597 1.333-1.333 0-.737-.596-1.334-1.333-1.334z"
        clip-rule="evenodd"
      />
    </svg>
  );
};

export default Camera;
